import {Base} from "@/api/Base"

export class LeaveTypeAdd extends Base {
    path = "leaveType/add"
}